import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { B2B_ORDER_URL } from 'utils/constans/constans';
import { formatPrice } from '../../utils/numberFormatter';
import { RowItems } from '../../models/TableProps';
import { InvoiceData } from '../../models/Invoice';

export const InvoiceDetailsTableRow: React.FC<RowItems<InvoiceData>> = (
    props
) => {
    const { row, index } = props;
    const { t } = useTranslation('invoices');
    const labelId = `enhanced-table-checkbox-${index}`;

    return (
        <TableRow hover>
            <TableCell id={labelId}>{row.invoiceNumber}</TableCell>
            <TableCell>{row.date}</TableCell>
            <TableCell>{row.paid}</TableCell>
            <TableCell>{row.paymentDeadline}</TableCell>
            <TableCell>{formatPrice(row.price_net)} Ft</TableCell>
            <TableCell>{formatPrice(row.price_gross)} Ft</TableCell>
            <TableCell>
                {row.status &&
                    row.status != ' ' &&
                    t(
                        'INVOICES.TABLE_CONTENT.STATUS.' +
                            row.status
                                .toString()
                                .toUpperCase()
                                .replace(' ', '_')
                    )}
            </TableCell>
            {/*<TableCell align="right">*/}
            {/*    <a href={B2B_ORDER_URL + row.shopifyOrderId}>*/}
            {/*        {row.shopifyOrderName}*/}
            {/*    </a>*/}
            {/*</TableCell>*/}
        </TableRow>
    );
};
